import { WebApiService } from '../../../plugins/webApiService'
import { Events } from '../../../plugins/events'
import { SendRequestModel } from '../../../plugins/models/SendRequestModel'
import StartAddFileBatchRequest from '../../../project-manager/files/i-services/models/request/StartAddFileBatchRequest';
import AbortAddFileRequest from '../../../project-manager/files/i-services/models/request/AbortAddFileRequest';
import SendFileChunkRequest from '../../../project-manager/files/i-services/models/request/SendFileChunkRequest';
import CompleteAddFileRequest from '../../../project-manager/files/i-services/models/request/CompleteAddFileRequest';
import ImportFilesFromUrlRequest from '../../../project-manager/files/i-services/models/request/ImportFilesFromUrlRequest';
import WsResponseModelT from '../../../schema-builder/server/models/WsResponseModelT';
import StartAddFileBatchResponse from '../../../project-manager/files/i-services/models/response/StartAddFileBatchResponse';
import AbortAddFileResponse from '../../../project-manager/files/i-services/models/response/AbortAddFileResponse';
import SendFileChunkResponse from '../../../project-manager/files/i-services/models/response/SendFileChunkResponse';
import CompleteAddFileResponse from '../../../project-manager/files/i-services/models/response/CompleteAddFileResponse';
import OnCompleteAddFileResponse from '../../../project-manager/files/i-services/models/response/OnCompleteAddFileResponse';
import FileImportResponse from '../../../project-manager/files/i-services/models/response/FileImportResponse';
import OnInitFilesCompleteResponse from '../../../project-manager/files/i-services/models/response/OnInitFilesCompleteResponse';
import OnFileProgressResponse from '../../../project-manager/files/i-services/models/response/OnFileProgressResponse';

/**
 * * Сервис файлов
 */
export default class FileService {
	private url?: string;
	private cookieName: string;
	private appWebSettingsPath?: string;
	private apiUrlProperty?: string;

	/**
	 * * Событие на завершение загрузки файла
	 */
	OnCompleteAddFileEvent = new Events<WsResponseModelT<OnCompleteAddFileResponse>>();
	OnInitFilesCompleteEvent = new Events<WsResponseModelT<OnInitFilesCompleteResponse>>();
	/**
	 * * Событие на отслеживание процесса загрузки файла
	 */
	OnFileProgressEvent = new Events<WsResponseModelT<OnFileProgressResponse>>();

	subscribeEvents = async () => {
		const self = this;
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		webApiService.on('FileService', 'OnCompleteAddFile', 'File', (res: WsResponseModelT<OnCompleteAddFileResponse>) => {
			self.OnCompleteAddFileEvent.trigger(res);
		});
		webApiService.on('FileService', 'OnInitFilesComplete', 'File', (res: WsResponseModelT<OnInitFilesCompleteResponse>) => {
			self.OnInitFilesCompleteEvent.trigger(res);
		});
		webApiService.on('FileService', 'OnFileProgress', 'File', (res: WsResponseModelT<OnFileProgressResponse>) => {
			self.OnFileProgressEvent.trigger(res);
		});
	}

	constructor(url?: string, cookieName?: string, appWebSettingsPath?: string, apiUrlProperty?: string) {
		this.url = url;
		this.cookieName = cookieName ?? "Auth-Token";
		this.appWebSettingsPath = appWebSettingsPath && [location.host, appWebSettingsPath].join("/");
		this.apiUrlProperty = apiUrlProperty;
		this.subscribeEvents();
	}

	/**
	 * * Начало добавления файлов пачкой
	 */
	async StartAddFileBatch(request: StartAddFileBatchRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'File',
			Controller: 'FileService',
			Method: 'StartAddFileBatch',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Отмена загрузки файла
	 */
	async AbortAddFile(request: AbortAddFileRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'File',
			Controller: 'FileService',
			Method: 'AbortAddFile',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Отправка части файла
	 */
	async SendFileChunk(request: SendFileChunkRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'File',
			Controller: 'FileService',
			Method: 'SendFileChunk',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Завершение добавления файла
	 */
	async CompleteAddFile(request: CompleteAddFileRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'File',
			Controller: 'FileService',
			Method: 'CompleteAddFile',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Импорт файлов по ссылке
	 */
	async ImportFilesFromUrl(request: ImportFilesFromUrlRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'File',
			Controller: 'FileService',
			Method: 'ImportFilesFromUrl',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	 // async methods
	/**
	 * * Начало добавления файлов пачкой
	 */
	async startAddFileBatchAsync(request: StartAddFileBatchRequest): Promise<StartAddFileBatchResponse> {
		return new Promise<StartAddFileBatchResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'File',
				Controller: 'FileService',
				Method: 'StartAddFileBatch',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<StartAddFileBatchResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as StartAddFileBatchResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Отмена загрузки файла
	 */
	async abortAddFileAsync(request: AbortAddFileRequest): Promise<AbortAddFileResponse> {
		return new Promise<AbortAddFileResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'File',
				Controller: 'FileService',
				Method: 'AbortAddFile',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<AbortAddFileResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as AbortAddFileResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Отправка части файла
	 */
	async sendFileChunkAsync(request: SendFileChunkRequest): Promise<SendFileChunkResponse> {
		return new Promise<SendFileChunkResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'File',
				Controller: 'FileService',
				Method: 'SendFileChunk',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<SendFileChunkResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as SendFileChunkResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Завершение добавления файла
	 */
	async completeAddFileAsync(request: CompleteAddFileRequest): Promise<CompleteAddFileResponse> {
		return new Promise<CompleteAddFileResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'File',
				Controller: 'FileService',
				Method: 'CompleteAddFile',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<CompleteAddFileResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as CompleteAddFileResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Импорт файлов по ссылке
	 */
	async importFilesFromUrlAsync(request: ImportFilesFromUrlRequest): Promise<FileImportResponse> {
		return new Promise<FileImportResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'File',
				Controller: 'FileService',
				Method: 'ImportFilesFromUrl',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<FileImportResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as FileImportResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

}